import React from 'react'
import diego1 from "../../media/Diego/diego1.jpg"
import diego2 from "../../media/Diego/diego2.jpg"
import diego3 from "../../media/Diego/diego3.jpg"


function Info() {
  return (
    <div>
        <div className="p-3 greenhouseBg">
              <h1 className="text-white tittle mt-5">DIEGO RODRIGUEZ LAGUENS</h1>
              <p className="text-white mb-5">Conoce la historia.</p>
        </div>

        <div className='d-flex flex-column p-3'>

          <img className="my-3" src={diego1} alt="diego1" />
          <p className="mt-4">
          Estudió Ingeniería Forestal en nuestra facultad y se recibió en el año 1992. Un 20 de febrero de 1994, Diego fue asesinado.
          A 27 años de su muerte, estudiantes, docentes y amigos/as de la Facultad de Ciencias Forestales, le rendimos homenaje. Nos sentimos orgullosos de que nuestro Centro de Estudiantes lleve su nombre, y cada año poder compartir su historia entre los que conformamos la comunidad forestal.
          </p>

          <img className="my-3" src={diego2} alt="diego1" />
          <img className="my-3" src={diego3} alt="diego1" />

        </div>
    </div>
  )
}

export default Info